<template>
  <div class="home_contents">
    <section>
        <v-layout column wrap class="my-6" align-center>
            <v-flex xs12>
            <v-container grid-list-xl>
                <v-layout row wrap align-start>
                <!-- 1つ目 -->
                <v-flex xs12 md6>
                    <v-card flat class="transparent">
                    <v-card-text class="text-center">
                        <v-icon size="80" class="red--text text--lighten-2">mdi-comment-remove-outline</v-icon>
                    </v-card-text>
                    <v-card-text class="display-1 text-center black--text">
                        今までの課題
                    </v-card-text>
                    </v-card>
                </v-flex>
                <v-flex xs12 md6>
                    <v-card flat class="transparent">
                    <v-card-text class="title mt-6 black--text">
                        ・RPA化したい業務があるが、どのくらい時間がかかるか分からない
                        <br />・本当は治したいRPAがあるけど治し方が分からずほったらかしている
                        <br />・動かなくなったRPAを今すぐ治したい...
                        <br />
                    </v-card-text>
                    </v-card>
                </v-flex>
                </v-layout>
            </v-container>
            </v-flex>
        </v-layout>
        <hr>

        <!-- RPAダッシュ！を使うと？ -->
        <v-layout column wrap align-center>
            <v-flex xs12 sm12 ma-4>
                <v-alert
                    color="#fafafa"
                    border="bottom"
                    prominent
                    min-width="100%"
                    class="display-1">
                    RPAダッシュ！を使うと？
                </v-alert>
            </v-flex>
            <v-flex xs12>
                <v-container grid-list-xl>
                    <v-layout row wrap align-start>
                    <!-- [1]標題 -->
                    <v-flex xs12 md1></v-flex>
                    <v-flex xs12 md3>
                        <v-card>
                        <v-card-text class="text-center">
                            <v-icon size="80" class="blue--text text--lighten-2">mdi-numeric-1-box-outline</v-icon>
                        </v-card-text>
                        <v-card-text class="title text-center black--text font-weight-bold">
                            困ったその時に相談予約
                            <br />
                        </v-card-text>
                        </v-card>
                    </v-flex>

                    <!-- [1]説明 -->
                    <v-flex xs12 md7>
                        <v-card flat class="transparent">
                        <v-card-text class="subtitle-1 black--text">
                            困った時点でご予約いただき、その時間になったらサポートを開始<span class="overline">(＊1)</span>いたします。
                            <br />50分間単位でご相談をうけたまわります。リモート接続により画面共有しながらご相談いただけますので、すぐに解決したい問題を、すぐに相談予約できるのが、RPAダッシュ！の良いところです。
                            <p class="caption">（*1:事前にリモート接続用のアプリケーションをインストールしておく必要があります。
                                <a @click="$vuetify.goTo('#usage', options)">
                                    詳しくは「ご利用の流れ（手順1）」
                                </a>
                                をご覧ください。）</p>
                        </v-card-text>
                        </v-card>
                    </v-flex>
                    <v-flex xs12 md1></v-flex>

                    <!-- [2]標題 -->
                    <v-flex xs12 md1></v-flex>
                    <v-flex xs12 md3>
                        <v-card>
                        <v-card-text class="text-center">
                            <v-icon size="80" class="blue--text text--lighten-2">mdi-numeric-2-box-outline</v-icon>
                        </v-card-text>
                        <v-card-text class="title text-center black--text font-weight-bold">
                            ノウハウを蓄積できる
                            <br />
                        </v-card-text>
                        </v-card>
                    </v-flex>
                    <!-- [2]説明 -->
                    <v-flex xs12 md7>
                        <v-card flat class="transparent">
                        <v-card-text class="subtitle-1 black--text">
                            RPA化が有効な業務、止まりにくいRPAの作り方、効率的なRPAの作り方など、誰かにまかせっきりだと手に入らないノウハウを自分のものとして吸収できます。
                            <br />現場主導でRPA化を進められるようにサポートいたします。
                        </v-card-text>
                        </v-card>
                    </v-flex>
                    </v-layout>
                </v-container>
            </v-flex>
        </v-layout>
    </section>

    <!-- ご提供できるもの -->
    <v-card outlined class="mx-auto ma-10" width="95%">
        <v-layout column wrap align-center>
            <v-flex xs12 sm12 ma-4>
                <v-alert
                    border="bottom"
                    prominent
                    min-width="100%"
                    class="display-1">
                    ご提供できる内容
                </v-alert>
            </v-flex>
        </v-layout>

        <!-- 1.レクチャー、2.個別相談、3技術的サポート -->
        <v-container>
            <v-row>
                <v-col
                    v-for="offer in offerings"
                    :key="offer.title"
                    class="col-xs-12 col-sm-12 col-md-4"
                >
                <v-card
                outlined
                min-height="240px"
                max-height="500px">
                    <p class="display-1 ma-4 text-center">{{offer.title}}</p>
                    <div class="ma-4">{{offer.content}}</div>
                    <v-img
                    contain="true"
                    class="white--text align-end"
                    :height="offer.height"
                    :src="offer.imgurl"
                    >
                    </v-img>
                </v-card>
                </v-col>
            </v-row>
        </v-container>
        <v-container fluid>
            <v-row justify="center">
                <v-btn
                    color="yellow darken-4"
                    dark
                    x-large
                    min-width="400px"
                    href="mailto:rpadash@ksk.co.jp?subject=RPAダッシュ！資料送付希望&amp;body=＊資料を返信いたしますので、このまま送信してください。%0d%0a株式会社KSK （AI推進室・RPAダッシュ担当）"
                    class="title">
                    資料を受け取る
                </v-btn>
            </v-row>
            <v-row justify="center">
                <div class="body-2 mt-2">
                    （＊メーラーが立ち上がらない場合は、題名「RPAダッシュ！資料送付希望」、本文なしで、<strong>rpadash@ksk.co.jp</strong>までメールをお送りください。）
                </div>
            </v-row>
        </v-container>
    </v-card>

    <!-- ご利用の流れ -->
    <section>
        <v-parallax src="../assets/supporter.jpg" height="300">
            <v-layout column align-center justify-center>
                <div id="usage" class="display-1 white--text mb-0 text-center">～ ご利用の流れ ～</div>
            </v-layout>
        </v-parallax>
        <v-container>
            <v-row justify="center">
                <v-col
                    v-for="card in cards"
                    :key="card.title"
                    class="col-xs-10 col-sm-8 col-lg-3"
                >
                <v-card
                outlined
                min-width="300px"
                min-height="290px"
                max-height="500px"
                >
                    <p class="display-1 ma-4 text-center">{{card.no}}</p>
                    <p class="title ma-4 text-center">{{card.title}}</p>
                    <v-divider></v-divider>
                    <div class="mx-4 mt-4">{{card.content}}</div>
                    <v-container fluid>
                        <v-row align="end" justify="center">
                            <v-card-actions  class="align-end">
                                <v-btn
                                    v-show='card.src'
                                    color="light-blue"
                                    dark
                                    :href='card.src'
                                    target="_brank">
                                    {{card.btntxt}}
                                    <v-icon right>
                                        mdi-open-in-new
                                    </v-icon>
                                </v-btn>
                            </v-card-actions>
                        </v-row>
                    </v-container>
                </v-card>
                </v-col>
            </v-row>
        </v-container>

        <!-- RPAダッシュ！を使うと？ -->
        <v-layout column wrap align-center>
            <v-flex xs12 sm10 ma-4>
                <v-alert
                    color="#fafafa"
                    border="bottom"
                    prominent
                    min-width="100%"
                    class="display-1">
                   無料キャンペーン実施中（先着10名まで！）
                </v-alert>
            </v-flex>
            <v-flex xs12 sm10 mx-12>
            <!-- [1]説明 -->
                <v-card flat class="transparent">
                    <v-card-text class="title black--text" id="tester_recruit">
                        「RPAダッシュ！」は現在ベータ版にて、無料キャンペーンを実施しています。<br>
                        キャンペーン利用者には利用の感想をお願いをしております。<br>
                        下記の予約システムより予約して、無料でお試しください。
                    </v-card-text>
                </v-card>
                <v-container fluid>
                    <v-row justify="center">
                        <v-btn :to="{name: 'reserve'}" color="yellow darken-4" dark x-large min-width="400px" class="headline">無料で試す</v-btn>
                    </v-row>
                </v-container>
            </v-flex>
        </v-layout>
    </section>

    <!-- 予約ボタン -->
    <ContactUs />
  </div>
</template>

<script>
import ContactUs from "@/components/ContactUs";
export default {
  data() {
    return {
      cards: [
        { no:'手順1',title: '・システムをインストール', content:'Web会議とリモート接続を行う為に「ミーティング用ZOOMクライアント」をインストールします。', src:'https://zoom.us/download',btntxt:'ZOOMクライアント', flex: 4 },
        { no:'手順2', title: '・動作を確認する',content:'カメラやマイクの動作に問題ないか、ネットワークの問題がないかなど、お手元の環境でZOOMの利用が可能であることを確認してください', flex: 4 },
        { no:'手順3', title: '・予約する',content:'予約システムより相談日時を選び、予約します。（この時、ZOOMの会議URLが発行されます） 今なら[無料で試す]ボタンより予約可能です。', flex: 4 },
        { no:'手順4',title: '・相談開始',content:'時間になりましたら、ZOOMの会議URLより、相談を開始してください。', flex: 4 },
      ],
      offerings:[
          {title:'1.レクチャー',content:'一般的なRPAの知識に関する知識のご提供を行います。例えばRPAの向き不向きや、RPA対象業務の洗い出し方などをご提供することで、社内にRPA化を進めるうえでのチェック項目や、RPA化候補業務の洗い出し方をご提供いたします。',imgurl:require('@/assets/lesson.jpg'),height:'200px'},
          {title:'2.個別相談',content:'RPA化をお考えの業務に対し、個別に削減工数シミュレーションや、開発工数の目安を算出する支援をいたします。お話をお聞きする中で、RPA化に適さない場合は業務フローの改善提案などを出すこともあります。',imgurl:require('@/assets/consulting.jpg'),height:'200px'},
          {title:'3.技術的サポート',content:'既にお作りになっているRPAの技術的な課題に対し、画面共有を行いながら直接技術サポートを実施いたします。（現在はUiPthのみサポート）',imgurl:require('@/assets/technical_support.jpg'),height:'200px'}
      ],
    };
  },
    components: {
        ContactUs
    },
};
</script>
